import { loadOptions } from '../../versa/formset.js';
import * as types from '../types.js';

export default {
	html: `
		<form id="customers-print-report" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="person_types"></datalist>
			<datalist id="ie_types"></datalist>
			<datalist id="states"></datalist>
			<p class="fss">Filtros opcionais. Deixe em branco para imprimir todos os clientes.</p>
			<div class="fsb">
				<label>Empresa
					<input id="company_id" type="text" list="companies">
				</label>
				<label>Estado (UF)
					<input id="billing_state" type="text" list="states" placeholder="ex: SP">
				</label>
				<label>Tipo
					<input id="type" type="text" list="person_types" placeholder="F, J ou L">
				</label>
			</div>
			<div class="fsb">
				<label>Tipo IE
					<input id="ie_type" type="text" list="ie_types">
				</label>
				<label>Consumidor
					<select id="is_end_consumer">
						<option value="">Todos</option>
						<option value="1">Sim</option>
						<option value="0">Não</option>
					</select>
				</label>
				<label>Formato
					<select id="format">
						<option value="pdf">PDF</option>
						<option value="csv">CSV</option>
						<option value="xlsx">Excel</option>
					</select>
				</label>
			</div>
			<div class="fsb mtm">
				<span id="count-msg" class="fss" style="color:#666;"></span>
				<span>
					<button type="button" class="bn_Escape button">Cancelar</button>
					<button type="submit" class="bn_Enter button">Gerar</button>
				</span>
			</div>
		</form>
	`,
	form: {
		selector: '#customers-print-report',
		init(formset) {
			const sel = formset.form?.selector || '#customers-print-report';
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			const optPerson = types.opt_person_type();
			if (optPerson?.options) loadOptions(`${sel} #type`, optPerson.options, 'value', ['label']);
			const optIe = types.opt_ie_type();
			if (optIe?.options) loadOptions(`${sel} #ie_type`, optIe.options, 'value', ['label']);
			const optUf = types.opt_uf();
			if (optUf?.options) loadOptions(`${sel} #billing_state`, optUf.options, 'value', ['label']);
			Object.getPrototypeOf(this).init.call(this);
		}
	},
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#billing_state' }, types: [types.opt_uf(), types.datalist()] },
		{ properties: { selector: '#type' }, types: [types.datalist()] },
		{ properties: { selector: '#ie_type' }, types: [types.datalist()] },
		{ properties: { selector: '#is_end_consumer' }, types: [] },
		{ properties: { selector: '#format' }, types: [] },
		{ properties: { selector: '#count-msg' }, types: [] }
	]
};
